import { CheckInDto, CreateCheckInDto } from '@careapp-group/ng-sdk';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';
import { createAction, props } from '@ngrx/store';

class CheckInActions extends CaEntityActionsFactory<
  CheckInDto,
  CreateCheckInDto,
  unknown,
  BaseFilterType
> {
  constructor() {
    super(`CheckIns`);
  }

  get REQUEST_FOR_SELECTED_CUSTOMER() {
    return `[${this.type}][Request] for selected customer`;
  }

  get REQUEST_FOR_CUSTOMER() {
    return `[${this.type}][Request] for customer`;
  }

  RequestCheckInsForCustomer = createAction(
    this.REQUEST_FOR_CUSTOMER,
    props<{ customerId: string }>()
  );

  RequestCheckInsForSelectedCustomer = createAction(this.REQUEST_FOR_SELECTED_CUSTOMER);
}

export const CheckIns = new CheckInActions();
